import { Icon } from '@iconify/react'

interface Props {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export default function Pagination({ currentPage, totalPages, onPageChange }: Props): React.JSX.Element {
  return (
    <div className="flex items-center justify-between mt-8 pt-4 text-xs tracking-tight text-[#3F3F45]">
      <span className="text-[#9C9C9F]">Showing <span className='text-[#101018]'>{currentPage}</span> of <span className='text-[#101018]'>{totalPages}</span></span>

      <div className="flex items-center gap-2">
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className={`flex items-center gap-1 px-[9px] py-[6px] h-[28px] border border-[#EDEDEE] rounded-md text-[12px] font-medium tracking-tight text-[#3F3F45] ${currentPage === 1 ? 'opacity-40 cursor-not-allowed' : 'hover:bg-[#F9F9FA] cursor-pointer'}`}
        >
          <Icon icon='solar:arrow-left-bold' width={14} />
          Previous
        </button>
        <button
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className={`flex items-center gap-1 px-[9px] py-[6px] h-[28px] border border-[#EDEDEE] rounded-md text-[12px] font-medium tracking-tight text-[#3F3F45] ${currentPage >= totalPages ? 'opacity-40 cursor-not-allowed' : 'hover:bg-[#F9F9FA] cursor-pointer'}`}
        >
          Next
          <Icon icon='solar:arrow-right-bold' width={14} />
        </button>
      </div>
    </div>
  )
}
